import { useState, useCallback } from 'react'
import { MOBILE_MENU_BREAKPOINT } from 'components/main-nav-bar/constants'

const getInitialIsMobileView = (): boolean => {
  if (typeof window !== 'undefined') {
    return window.innerWidth < MOBILE_MENU_BREAKPOINT
  }
  return false
}

export const useNavUIState = () => {
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null)
  const [activeMobileDropdown, setActiveMobileDropdown] = useState<string | null>(null)
  const [languageHeaderHeight, setLanguageHeaderHeight] = useState(0)
  const [isMobileView, setIsMobileView] = useState<boolean>(getInitialIsMobileView())
  const [isScrolled, setIsScrolled] = useState(false)
  const [isHeaderGroupVisible, setIsHeaderGroupVisible] = useState(true)
  const [isLanguageHeaderVisible, setIsLanguageHeaderVisible] = useState(true)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const toggleDropdown = useCallback((name: string) => {
    setActiveDropdown(curr => (curr === name ? null : name))
  }, [])

  const openMobileSubmenu = useCallback((name: string) => {
    setActiveMobileDropdown(name)
  }, [])

  const closeMobileSubmenu = useCallback(() => {
    setActiveMobileDropdown(null)
  }, [])

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen(prev => {
      const nextOpenState = !prev
      document.body.classList.toggle('mobile-nav-active', nextOpenState)
      if (!nextOpenState) {
        setActiveMobileDropdown(null)
      }
      return nextOpenState
    })
  }, [])

  const handleResize = useCallback(() => {
    if (typeof window === 'undefined') return
    const newIsMobile = window.innerWidth < MOBILE_MENU_BREAKPOINT

    if (newIsMobile !== isMobileView) {
      setIsMobileView(newIsMobile)
      if (!newIsMobile && isMobileMenuOpen) {
        setIsMobileMenuOpen(false)
        document.body.classList.remove('mobile-nav-active')
        setActiveMobileDropdown(null)
      }
    }
  }, [isMobileView, isMobileMenuOpen])

  return {
    activeDropdown,
    activeMobileDropdown,
    languageHeaderHeight,
    isMobileView,
    isScrolled,
    isHeaderGroupVisible,
    isLanguageHeaderVisible,
    isMobileMenuOpen,

    setActiveDropdown,
    setActiveMobileDropdown,
    setLanguageHeaderHeight,
    setIsMobileView,
    setIsScrolled,
    setIsHeaderGroupVisible,
    setIsLanguageHeaderVisible,
    setIsMobileMenuOpen,

    toggleDropdown,
    openMobileSubmenu,
    closeMobileSubmenu,
    toggleMobileMenu,
    handleResize,
  }
}
